exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel{\r\n\tbackground-color: rgba(240,240,240,0.9);\r\n\tmin-height: 40vh;\r\n\tpadding: 20px;\r\n\ttext-align: center;\r\n\tmargin-top: 20px;\r\n}\r\n.invalid{\r\n\tborder-left: 5px solid #a94442;\r\n}\r\n.errorText{\r\n\tfont-size: 16px;\r\n\tcolor: #a94442;\r\n}\r\n.buttonContainer{\r\n\tmargin-top:90px;\r\n}\r\n.submitButton{\r\n\tborder-color: rgb(220,30,0);\r\n\tbackground-color: rgb(255,63,0);\r\n}\r\n.submitButton:active{\r\n\tborder-color: rgb(180,15,0);\r\n\tbackground-color: rgb(220,30,0);\r\n}\r\n.submitButton:disabled{\r\n\tborder-color: rgb(180,15,0);\r\n\tbackground-color: rgb(255,90,45);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/app/editprofile/editprofile.component.css
// module id = ../../../../../src/app/editprofile/editprofile.component.css
// module chunks = main